<template>
  <div class="labor-page" id="talent" :key="`root-${pageKey}`">
    <div class="main-contain" id="scroller">
      <LaborHero
        :key="`hero-${pageKey}`"
        :active-tab="activeTab"
        :top-navs="topNavs"
        :breadcrumbs="breadcrumbs"
        :tabs="tabs"
        @toggle-language="toggleLanguage"
        @change-tab="setActiveTab"
      />

      <LaborServiceTabs
        :key="`tabs-${pageKey}`"
        :active-tab="activeTab"
        :labor-services="laborServices"
        :talent-services="talentServices"
        :manage-services="manageServices"
      />

      <LaborContactForm :key="`contact-${pageKey}`" :contact-form="contactForm" />

      <SiteFooter :key="`footer-${pageKey}`" />
    </div>
  </div>
</template>

<script>
import LaborHero from '@/components/layout/laborRelations/sections/LaborHero.vue'
import LaborServiceTabs from '@/components/layout/laborRelations/sections/LaborServiceTabs.vue'
import LaborContactForm from '@/components/layout/laborRelations/sections/LaborContactForm.vue'
import SiteFooter from '@/components/layout/newHome/sections/SiteFooter.vue'

export default {
  name: 'LaborRelations',
  components: { LaborHero, LaborServiceTabs, LaborContactForm, SiteFooter },
  data() {
    return {
      activeTab: 'labor',
      topNavs: [
        { key: 'home', labelKey: 'laborRelations.nav.home', href: '/' },
        { key: 'about', labelKey: 'laborRelations.nav.about', href: '/home/about-xc' },
        { key: 'products', labelKey: 'laborRelations.nav.products', href: '/home/menu' },
        { key: 'news', labelKey: 'laborRelations.nav.news', href: '/home/news' },
        { key: 'jobs', labelKey: 'laborRelations.nav.jobs', href: '/home/jobs' },
        { key: 'party', labelKey: 'laborRelations.nav.party', href: '/home/menu' }
      ],
      breadcrumbs: [
        { key: 'home', labelKey: 'laborRelations.breadcrumb.home', href: '/' },
        { key: 'sep1', labelKey: 'laborRelations.breadcrumb.sep', href: null },
        { key: 'products', labelKey: 'laborRelations.breadcrumb.products', href: '/home/menu' },
        { key: 'sep2', labelKey: 'laborRelations.breadcrumb.sep', href: null },
        { key: 'current', labelKey: 'laborRelations.breadcrumb.current', href: null }
      ],
      tabs: [
        { key: 'labor', labelKey: 'laborRelations.tabs.labor' },
        { key: 'talent', labelKey: 'laborRelations.tabs.talent' },
        { key: 'manage', labelKey: 'laborRelations.tabs.manage' }
      ],
      laborServices: [
        { titleKey: 'laborRelations.services.laborOutsourcing.title', contentKey: 'laborRelations.services.laborOutsourcing.content', image: require('@/static/image/pro-lab2.png'), reverse: true },
        { titleKey: 'laborRelations.services.laborDispatch.title', contentKey: 'laborRelations.services.laborDispatch.content', image: require('@/static/image/pro-lab3.png'), reverse: false },
        { titleKey: 'laborRelations.services.flexEmployment.title', contentKey: 'laborRelations.services.flexEmployment.content', image: require('@/static/image/pro-lab4.png'), reverse: true }
      ],
      manageServices: [
        { titleKey: 'laborRelations.services.hrStrategy.title', contentKey: 'laborRelations.services.hrStrategy.content', image: require('@/static/image/pro-manage2.png'), anchor: 'rlzy' },
        { titleKey: 'laborRelations.services.strategyPlanning.title', contentKey: 'laborRelations.services.strategyPlanning.content', image: require('@/static/image/pro-manage3.png'), anchor: 'zlgh' },
        { titleKey: 'laborRelations.services.groupConsulting.title', contentKey: 'laborRelations.services.groupConsulting.content', image: require('@/static/image/pro-manage4.png'), anchor: 'jth' }
      ],
      talentServices: [
        { titleKey: 'laborRelations.services.talentRecruit.title', contentKey: 'laborRelations.services.talentRecruit.content', image: require('@/static/image/pro_rcfw1.png') },
        { titleKey: 'laborRelations.services.talentAssess.title', contentKey: 'laborRelations.services.talentAssess.content', image: require('@/static/image/pro_rcfw2.png') },
        { titleKey: 'laborRelations.services.archiveManage.title', contentKey: 'laborRelations.services.archiveManage.content', image: require('@/static/image/pro_rcfw3.png') }
      ],
      contactForm: {
        titleKey: 'laborRelations.contact.title',
        subtitleKey: 'laborRelations.contact.subtitle',
        typeCompanyKey: 'laborRelations.contact.typeCompany',
        typePersonKey: 'laborRelations.contact.typePerson',
        questionLabelKey: 'laborRelations.contact.questionLabel',
        nameLabelKey: 'laborRelations.contact.nameLabel',
        phoneLabelKey: 'laborRelations.contact.phoneLabel',
        submitKey: 'laborRelations.contact.submit',
        hotlineTimeKey: 'laborRelations.contact.hotlineTime'
      }
    }
  },
  computed: {
    pageKey() {
      const locale = (this.$i18n && this.$i18n.locale) || 'zh-CN'
      const routeLang = (this.$route && this.$route.query && this.$route.query.lang) || ''
      return `${locale}-${routeLang}`
    }
  },
  watch: {
    '$route.query.tab'() {
      this.applyTabFromQuery()
    }
  },
  created() {
    this.applyTabFromQuery()
  },
  methods: {
    applyTabFromQuery() {
      const tab = this.$route && this.$route.query ? this.$route.query.tab : ''
      const validTabs = ['labor', 'talent', 'manage']
      if (validTabs.includes(tab)) {
        this.activeTab = tab
      }
    },
    toggleLanguage() {
      const currentLocale = (this.$i18n && this.$i18n.locale) || 'zh-CN'
      const nextLocale = currentLocale === 'zh-CN' ? 'en' : 'zh-CN'

      console.log('[LaborRelations toggleLanguage] before', {
        currentLocale,
        nextLocale,
        routeQueryLang: this.$route && this.$route.query && this.$route.query.lang,
        localStorageLang: localStorage.getItem('locale')
      })

      this.$i18n.locale = nextLocale
      localStorage.setItem('locale', nextLocale)

      console.log('[LaborRelations toggleLanguage] after set', {
        i18nLocale: this.$i18n.locale,
        localStorageLang: localStorage.getItem('locale')
      })

      if (this.$router && this.$route) {
        this.$router.replace({
          path: this.$route.path,
          query: { ...this.$route.query, lang: nextLocale },
          hash: this.$route.hash
        }).catch(err => {
          console.log('[LaborRelations toggleLanguage] router error', err)
        })
      }

      this.$nextTick(() => {
        console.log('[LaborRelations toggleLanguage] nextTick', {
          i18nLocale: this.$i18n.locale,
          routeQueryLang: this.$route && this.$route.query && this.$route.query.lang
        })
        this.$forceUpdate()
      })
    },
    setActiveTab(tab) {
      this.activeTab = tab
      if (this.$router && this.$route) {
        this.$router.replace({
          path: this.$route.path,
          query: { ...this.$route.query, tab },
          hash: this.$route.hash
        }).catch(() => {})
      }
    }
  }
}
</script>

<style scoped>
.labor-page { background: #fff; }
</style>
